import React, { useEffect, useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';

import { ChartWidget } from 'itaf';

import CadastroService from '../../../services/CadastroService';

const month = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul","Ago","Set","Out","Nov","Dez"];

export default function RegimeTributarioWidget({ onFullScreen }) {
  const [data, setDashboardRegimes] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const title = "Evolução de CNPJ por Regime Tributário";

  useEffect(() => {
    loadDashboardRegimes();
  }, []);

  function loadDashboardRegimes() {
    setLoading(true);
    CadastroService.fetchDashboardCnpjRegimes()
      .then(async (res) => {
        if (res.ok) {
          const body = await res.json();
          setDashboardRegimes(body);
        }
      })
      .finally(setLoading(false));
  }

  const tooltip = ({ label, id, indexValue, formattedValue, color }) => (
    <div style={{
      background: 'white', 
      color: 'inherit',
      fontSize: 'inherit',
      borderRadius: '2px', 
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 2px',
      padding: '5px 9px'}}
    >
      <div style={{
        whiteSpace: 'pre', display: 'flex', alignItems: 'center',
      }}>
        <span style={{
          display: 'block', width: '12px', height: '12px', 
          background: color, marginRight: '7px' }}
        />
        <strong>
          {label} ({formattedValue})
        </strong>
      </div>
    </div>
  );

  if (!data && !isLoading) {
    return (<div></div>);
  }

  return (
    <ChartWidget title={title}
      isLoading={isLoading}
      onFullScreen={onFullScreen}>
      <ResponsiveBar
        data={data}
        keys={[
          'mei',
          'simples',
          'presumido',
          'real'
        ]}
        indexBy="ano"
        groupMode="grouped"
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        margin={{ top: 16, right: 8, bottom: 72, left: 64 }}
        colors={{ scheme: 'dark2' }}
        animate={true}
        yScale={{
          type: 'linear',
          min: 'auto',
          max: 'auto',
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          orient: 'bottom',
          tickSize: 10,
          tickPadding: 5,
          legend: 'Ano',
          legendOffset: 42,
          legendPosition: 'middle',
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Quantidade (x 100.000)',
          legendPosition: 'middle',
          legendOffset: -50,
          truncateTickAt: 0,
          format: (value) => value / 100000
        }}
        valueFormat={(value) => Number(value).toLocaleString('pt-BR')}
        enableLabel={true}
        enableGridY={true}
        enablePointLabel={false}
        enableTotals={false}
        totalsOffset={10}
        // maxValue={19000000}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabelYOffset={-12}
        labelOffset={10}
        labelPosition="end"
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: 'color',
          modifiers: [
            [
              'darker',
              1.6
            ]
          ]
        }}
        tooltip={tooltip}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 72,
            itemsSpacing: 2,
            itemWidth: 112,
            itemHeight: 16,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 16,
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        role="application"
        ariaLabel={title}
      />
    </ChartWidget>
  );
}
